import React, { useMemo } from "react";
import { useLocation, Link, matchPath } from "react-router-dom";

const Breadcrumbs = () => {
  const location = useLocation();

  // Combine all routes inside the component to avoid circular dependency initialization errors
  const allRoutes = useMemo(() => {
    // Lazily require routes inside render to break the ES module circular dependency 
    const { commercialRoutes } = require("../../../app/router/modules/commercialRoutes");
    const { residentialRoutes } = require("../../../app/router/modules/residentialRoutes");

    return [
      ...commercialRoutes.map(r => ({ ...r, path: `/zentcomm/${r.path}` })),
      ...residentialRoutes.map(r => ({ ...r, path: `/zentres/${r.path}` })),
      // Future: ...corporateRoutes.map(r => ({ ...r, path: `/zentcorp/${r.path}` }))
    ];
  }, []);

  const currentRoute = allRoutes.find(
    (route) => matchPath(route.path, location.pathname)
  );

  if (!currentRoute) return null;
  const crumbs = currentRoute.breadcrumbs || [];

  const getPathForCrumb = (index) => {
    const targetSequence = crumbs.slice(0, index + 1);

    // Try to find an exact breadcrumb match
    const exactMatch = allRoutes.find(r =>
      r.breadcrumbs &&
      r.breadcrumbs.length === targetSequence.length &&
      r.breadcrumbs.every((c, i) => c === targetSequence[i])
    );

    if (exactMatch) return exactMatch.path;

    // Fallback: find first route that starts with this sequence (for parent categories)
    const prefixMatch = allRoutes.find(r =>
      r.breadcrumbs &&
      r.breadcrumbs.length >= targetSequence.length &&
      targetSequence.every((c, i) => r.breadcrumbs[i] === c)
    );

    return prefixMatch ? prefixMatch.path : null;
  };

  return (
    <div className="text-xs text-breadcrumbinactive flex items-center gap-2 mb-2 flex-wrap">
      {crumbs.map((crumb, index) => {
        const path = getPathForCrumb(index);
        const isLast = index === crumbs.length - 1;

        return (
          <div key={index} className="flex items-center gap-2">
            {isLast || !path ? (
              <span className="font-semibold text-breadcrumbactive">
                {crumb}
              </span>
            ) : (
              <Link
                to={path}
                className="hover:text-indigo-600 dark:hover:text-breadcrumbactive hover:underline transition-colors cursor-pointer"
              >
                {crumb}
              </Link>
            )}

            {!isLast && <span>/</span>}
          </div>
        );
      })}
    </div>
  );
};

export default Breadcrumbs;